import type { FeatureFlagsResponse, AdminFeatureFlag } from "@atlas/shared";
import { apiGet, apiPatch } from "../lib/api-client";

export type { FeatureFlags, AdminFeatureFlag } from "@atlas/shared";

export function fetchFeatureFlags(): Promise<FeatureFlagsResponse> {
  return apiGet("/flags");
}

export function fetchAdminFeatureFlags(): Promise<{ flags: AdminFeatureFlag[] }> {
  return apiGet("/flags/admin");
}

export function updateFeatureFlag(
  key: string,
  enabled: boolean,
): Promise<{ flag: { key: string; enabled: boolean; updatedAt: string | null } }> {
  return apiPatch(`/flags/admin/${encodeURIComponent(key)}`, { enabled });
}
